import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  SimulationPack,
  SimulationPackService,
} from '../simulation-pack.service';
import { UtilsService } from '@app/providers/utils/utils.service';
import { SwiperOptions } from 'swiper';
import * as _ from 'lodash';
import { BreakpointObserver } from '@angular/cdk/layout';

const bulletStyles =
  'width: 14px;height: 14px;border-radius: 20px; margin:-26px 3px';
@Component({
    selector: 'simulation-packs',
    templateUrl: './simulation-packs.component.html',
    styleUrls: ['./simulation-packs.component.scss'],
    standalone: false
})
export class SimulationPacksComponent implements OnInit {
  @ViewChild('swiper', { read: ElementRef }) swiper?: ElementRef;
  public config: SwiperOptions = {
    observer: true,
    a11y: { enabled: true },
    direction: 'horizontal',
    keyboard: true,
    mousewheel: false,
    scrollbar: false,
    pagination: {
      clickable: true,
      type: 'custom',
      renderCustom(swiper, current, total) {
        let out = '';
        for (let i = 1; i <= total; i++) {
          const isActive = i === current;
          out += `
            <span
              style="${bulletStyles}"
              class="swiper-pagination-bullet ${
                isActive ? 'swiper-pagination-bullet-active' : ''
              }"
              tabindex="${i}"
              role="button"
              aria-label="Go to slide ${i + 1}"
            ></span>
          `;
        }
        return out;
      },
    },
    slidesPerView: 'auto',
    touchStartPreventDefault: false,
    centeredSlides: false,
    slideToClickedSlide: true,
    spaceBetween: 20,
    slidesOffsetAfter: 0,
    slidesOffsetBefore: 0,
    threshold: 10,
    navigation: true,
    breakpoints: {
      760: {
        freeMode: true,
      },
    },
  };
  @Input() withoutManual = true;
  @Input() withCustomPack = true;
  @Input() withPanelTitle = true;
  @Input() suitableBaseOnScore = undefined;
  @Input() set simulation(simulation) {
    this._simulation = simulation;
    if (this.packs) {
      this.availablePacks = undefined;
      setTimeout(() => {
        this.availablePacks = this.getAvailablePacks();
      }, 0);
    }
  }
  get simulation() {
    return this._simulation;
  }
  _simulation: any = {};

  packs: SimulationPack[] = [];
  availablePacks: SimulationPack[] = [];
  @Output() packSelected: EventEmitter<SimulationPack> = new EventEmitter();
  @Output() onEdit?: EventEmitter<any> = new EventEmitter();

  constructor(
    private simulationPackService: SimulationPackService,
    public utils: UtilsService,
    private breakpointObserver: BreakpointObserver,
  ) {
    this.simulationPackService.packsChangedSubject.subscribe(packs => {
      this.packs = _.filter(packs, item => item.id != null);
      this.availablePacks = this.packs;
      if (!this.withoutManual) {
        this.packs = packs;
      }

      if (!this.withCustomPack)
        this.packs = this.packs.filter(pack => pack?.id);

      setTimeout(() => {
        this.availablePacks = this.getAvailablePacks();
        // this.componentRef.initSwiper();
      }, 0);
    });
  }

  ngOnInit() {
    const isMobile = this.breakpointObserver.isMatched('(max-width: 576px)');

    if (isMobile) {
      this.config.navigation = false;
    }
  }

  selectPack(pack) {
    this.simulationPackService.selectPack(pack);
    this.packSelected.emit(pack);
  }

  getAvailablePacks(): SimulationPack[] {
    return this.packs;
  }

  get selectedPack() {
    return this.simulationPackService.selectedPack;
  }

  triggerForm() {
    this.simulationPackService.startAllocationForm(
      this.simulation.parameters,
      this.simulationPackService.selectedPack.id
        ? this.simulationPackService.selectedPack.allocation
        : undefined,
    );
    if (this.simulationPackService.selectedPack.id)
      this.simulationPackService.selectPack(
        this.simulationPackService.getCustomPack(),
      );
  }
}
